import React from "react";

import { FileRecordStatus } from "../../../../../../../common/types/FileRecordStatus";
import { FileRecordQcDoneDialog } from "../../../../../common/components/qc-done/FileRecordQcDoneDialog";
import { FileRecordStatusDetails } from "../../../../../common/types/FileRecordStatusDetails";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import { DestroyStatusDialog } from "./DestroyStatusDialog";
import { EditingStatusDialog } from "./EditingStatusDialog";
import { QcStatusDialog } from "./QcStatusDialog";
import { RejectStatusDialog } from "./RejectStatusDialog";
import { WaitingForClientResponseStatusDialog } from "./WaitingForClientResponseStatusDialog";

interface FileRecordStatusDialogManagerProps {
    status?: FileRecordStatus;
    isOpen: boolean;
    onDismiss: () => void;
    onConfirm: (statusDetails?: FileRecordStatusDetails) => void;
}

export const FileRecordStatusDialogManager = ({
    status,
    isOpen,
    onDismiss,
    onConfirm
}: FileRecordStatusDialogManagerProps): JSX.Element => {
    const { fileRecordDetails, setStatus } = useFileRecordDetailsState();

    switch (status) {
        case FileRecordStatus.Rejected:
            return (
                <RejectStatusDialog
                    isOpen={isOpen}
                    onClose={onDismiss}
                    onConfirm={onConfirm}
                    fileRecordId={fileRecordDetails.id}
                />
            );
        case FileRecordStatus.Editing:
            return <EditingStatusDialog isOpen={isOpen} onClose={onDismiss} />;
        case FileRecordStatus.Destroyed:
            return <DestroyStatusDialog isOpen={isOpen} onClose={onDismiss} />;
        case FileRecordStatus.QcDone:
            return (
                <FileRecordQcDoneDialog
                    itemId={fileRecordDetails.id}
                    onSubmit={() => setStatus(FileRecordStatus.QcDone)}
                    isOpen={isOpen}
                    onClose={onDismiss}
                />
            );
        case FileRecordStatus.Qc:
            return <QcStatusDialog isOpen={isOpen} onClose={onDismiss} />;
        case FileRecordStatus.WaitingForClientResponse:
            return (
                <WaitingForClientResponseStatusDialog
                    isOpen={isOpen}
                    onClose={onDismiss}
                    onConfirm={onConfirm}
                    fileRecordId={fileRecordDetails.id}
                />
            );

        default:
            return <></>;
    }
};
